// COPY de apps/desktop/src/...; dedup em F13 via packages/shared-ui.
import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="f4-empty-state" role="status">
      <span className="f4-empty-state__title">{title}</span>
      {description !== undefined ? (
        <span className="f4-empty-state__description muted">{description}</span>
      ) : null}
      {action !== undefined ? <div className="f4-empty-state__action">{action}</div> : null}
    </div>
  );
}
